import { useCallback, useEffect, useState } from "react";

type executeRecaptchaReturnType = {
  reCaptchaToken: string;
  reCaptchaAction: string;
};

const useRecaptchaV3 = (
  siteKey: string,
  isRecaptchaEnabled: boolean,
): ((action: string) => Promise<executeRecaptchaReturnType>) => {
  const [isRecaptchaReady, setIsRecaptchaReady] = useState<boolean>(false);

  useEffect(() => {
    if (isRecaptchaEnabled) {
      if (window.grecaptcha) {
        setIsRecaptchaReady(true);
      } else {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        document.head.appendChild(script);
        script.onload = () => setIsRecaptchaReady(true);
      }
    }
  }, [siteKey]);

  const executeRecaptcha = useCallback(
    async (action: string): Promise<executeRecaptchaReturnType> => {
      if (isRecaptchaReady && window.grecaptcha) {
        const reCaptchaToken = await window.grecaptcha.execute(siteKey, {
          action,
        });
        return {
          reCaptchaToken,
          reCaptchaAction: action,
        };
      }
      return {
        reCaptchaToken: "",
        reCaptchaAction: action,
      };
    },
    [isRecaptchaReady, siteKey],
  );

  return executeRecaptcha;
};

export default useRecaptchaV3;
